import { TabView, TabPanel } from 'primereact/tabview';
import CoreValues from './vision/CoreValues';
import CoreFocus from './vision/CoreFocus';
import MarketStrategy from './vision/MarketStrategy';
import GoMarketStrategy from './vision/GoMarketStrategy';
import YearPicture from './vision/YearPicture';
import YaerPaln from './Goal/YaerPaln';
import RocksTarget from './Goal/RocksTarget';
import LongTermIssues from './Goal/LongTermIssues';
import Strength from './Swot/Strength';
import Opportunities from './Swot/Opportunities';
import Weaknesses from './Swot/Weaknesses';
import Threats from './Swot/Threats';

const BusinessCore1 = () => {
    const tabHeaderStyle = {
        margin: '10px',
        padding: ' 20px',
    };

    const tabPanelContentStyle = {
        maxHeight: 'calc(100vh - 140px)', // Adjust this value based on your design
        overflowY: 'auto', // Enable vertical scroll


    };

    return (
<>

        <div className="continer mt-4">
            <div className="card">
                <TabView>
                    <TabPanel header={<span style={tabHeaderStyle} className='subtitle-font'>VISION</span>}>
                        <div style={tabPanelContentStyle}>
                            <div className="row mt-3 px-4">
                                <div className="col-8">
                                    {/* core value */}
                                    <CoreValues />
                                    {/* Core Focus™ */}
                                    <CoreFocus />
                                    {/* 10-Year Target™ */}
                                    <MarketStrategy />
                                    {/* Go to Market Strategy */}
                                    <GoMarketStrategy />
                                </div>
                                {/* 3-Year Picture */}
                                <div className="col-4">
                                    <YearPicture />
                                </div>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel header={<span style={tabHeaderStyle} className='subtitle-font'>GOAL</span>}>
                        <div style={tabPanelContentStyle}>
                            <div className="row mt-3 px-5">
                                <div className="col-4">
                                    <RocksTarget />
                                </div>
                                <div className="col-4">
                                    <YaerPaln />
                                </div>
                                <div className="col-4">
                                    <LongTermIssues />
                                </div>

                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel header={<span style={tabHeaderStyle} className='subtitle-font'>SWOT</span>}>
                        <div className='px-4' style={tabPanelContentStyle}>
                            <div className="row mt-3">
                                <div className="col-6">
                                    <Strength />
                                </div>
                                <div className="col-6">
                                    <Weaknesses />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <Opportunities />
                                </div>
                                <div className="col-6">
                                    <Threats />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
        </>
    );
};

export default BusinessCore1;
